// any-types are coming from generates specs
/* eslint-disable @typescript-eslint/no-explicit-any */

import type { Country } from '../../../standards/Country'

export const RESOLUTION_OPTIONS_ACTIONS_ENUM = {
  createShipment: 'CREATE_SHIPMENT',
  showDataRemoval: 'SHOW_DATA_REMOVAL',
  showPictures: 'SHOW_PICTURES',
  showPicturesWithIntro: 'SHOW_PICTURES_WITH_INTRO',
  showMessage: 'SHOW_MESSAGE',
} as const

export const RESOLUTION_OPTION_SERVICE_NAME_ENUM = {
  asp: 'ASP',
  backRepair: 'BACKREPAIR',
  orderManagement: 'ORDER_MANAGEMENT',
} as const

export const RESOLUTION_OPTION_TYPE_ENUM = {
  factoryRepair: 'FACTORY_REPAIR',
  shopRepair: 'SHOP_REPAIR',
  repairReplace: 'REPAIR_REPLACE',
  remoteAssistance: 'REMOTE_ASSISTANCE',
  refund: 'REFUND',
  sellerRepair: 'SELLER_REPAIR',
  sellerReplace: 'SELLER_REPLACE',
  replace: 'REPLACE',
  liveChat: 'LIVE_CHAT',
  straightRefund: 'STRAIGHT_REFUND',
} as const

export type GetResolutionOptionsActionsEnum =
  (typeof RESOLUTION_OPTIONS_ACTIONS_ENUM)[keyof typeof RESOLUTION_OPTIONS_ACTIONS_ENUM]

export type GetResolutionOptionsServiceNameEnum =
  (typeof RESOLUTION_OPTION_SERVICE_NAME_ENUM)[keyof typeof RESOLUTION_OPTION_SERVICE_NAME_ENUM]

export type GetResolutionOptionsTypeEnum =
  (typeof RESOLUTION_OPTION_TYPE_ENUM)[keyof typeof RESOLUTION_OPTION_TYPE_ENUM]

export interface GetResolutionOptionsPayload {
  declaredProblem: any
}

export type ResolutionOption = {
  actions: GetResolutionOptionsActionsEnum[]
  type: GetResolutionOptionsTypeEnum
  serviceName: GetResolutionOptionsServiceNameEnum
  isDataRemovalRequired: boolean
  isShipmentRequired: boolean
  createShipment: boolean
  dispatchAddress: {
    id: string
    street: string
    city: string
    postalCode: string
    country: Country
    company: string | null
    street2: string | null
    stateOrProvince: string | null
  } | null
  deliveryAddressId: string | null
}

export interface GetResolutionOptionsData {
  resolutionOptions?: ResolutionOption[]
  /**
   * display tooltip if seller does not provide repair/replace
   * @example false
   */
  displayNoRepairTooltip?: boolean
}
